// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-positive-negative{display:flex;align-items:center;padding:2px 4px;background:#f7f8fa;font-size:12px;border-radius:2px;min-width:78px}.common-positive-negative.is-positive{color:#c81919}.common-positive-negative.is-negative{color:#009b37}", ""]);
// Exports
module.exports = exports;
